import { type FC, ButtonHTMLAttributes, useMemo, useContext } from 'react'

import { AppContext } from '@/components/context/AppContext'
import { getButtonDataAttributes } from '@/utils/miscellaneous'
import { twMerge } from '@/utils/tailwind'
import type { GoogleDataAttributes } from '@/types/miscellaneous'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, GoogleDataAttributes {
  appearance?: 'filled' | 'outlined' | 'ghost';
}

const Button: FC<ButtonProps> = ({ type = 'button', className, appearance = 'filled', gtag, children, ...restProps }) => {
  const { dataAction } = useContext(AppContext)

  const {
    dataCategory,
    dataLabel
  } = useMemo(() => getButtonDataAttributes(gtag.name, dataAction), [gtag, dataAction])

  const btnClassName = useMemo(() => (
    {
      'filled': 'tw-bg-ui-red tw-text-white',
      'outlined': 'tw-bg-transparent tw-text-ui-red tw-border-2 tw-border-ui-red',
      'ghost': 'tw-bg-transparent tw-text-ui-red tw-border-0'
    }[appearance]
  ), [appearance])

  return (
    <button type={type}
            className={twMerge('tw-text-lg tw-font-semibold tw-rounded-3xl tw-px-8 tw-py-2 disabled:tw-bg-opacity-75 disabled:tw-cursor-not-allowed hover:tw-bg-opacity-90 tw-transition tw-duration-200', btnClassName, className)}
            data-category={dataCategory}
            data-action={dataAction}
            data-label={dataLabel}
            {...restProps}>
      {children}
    </button>
  )
}

export default Button
